import styled, { css, keyframes } from "styled-components";

export const Timer4Wrapper = styled.div`
  background: #00142c;
  width: 100%;
  height: 100vh;
  gap: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  > .background {
    background: #000000c4;
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
`;

export const Timer4Background = styled.div<{ backgroundImage: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ backgroundImage }) =>
    `url(${backgroundImage}) lightgray 50% / cover no-repeat`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: blur(2.5px);
  opacity: 0.4;
`;

export const Timer4Body = styled.div`
  position: relative;
  flex: 1;
  width: calc(100% - 60px);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Timer4Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  > .now-level {
    margin-top: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 783px;
    height: 79px;
    border-radius: 25px;
    background: #002f68;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 37.738px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  > .time {
    z-index: 2;
    margin-top: 20px;
    color: #fff;
    text-align: center;
    text-shadow: 0px 0px 30px rgba(255, 255, 255, 0.5), 0px 0px 80px #6436e7;
    font-family: Pretendard;
    font-size: 250px;
    font-style: normal;
    font-weight: 900;
    line-height: 100%; /* 250px */
    letter-spacing: -10px;
  }

  > .time.break {
    color: #ff6868;
    text-shadow: none;
  }
  > .logo {
    margin-top: -15px;
  }
  > .timer-wrapper {
    transform: rotateX(73deg);
    position: absolute;
    top: -15px;

    > img {
      position: absolute;
      top: -20px;
      left: -20px;
    }
  }
`;

export const Timer4TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  > img {
    width: 80px;
    height: 80px;
    border-radius: 80px;
    object-fit: cover;
  }

  > .title-wrapper {
    display: flex;
    flex-direction: column;

    > .title {
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 45px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }

    > .type {
      color: #fff;
      font-family: Pretendard;
      font-size: 35px;
      font-style: normal;
      line-height: normal;
      font-weight: 500;
    }
  }
`;

export const Timer4Header = styled.div`
  width: calc(100% - 60px);
  position: relative;
  height: 98px;
  padding: 40px 30px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  > .pub-name {
    color: #fff;
    text-align: right;
    font-family: Pretendard;
    font-size: 35px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const Circle4 = styled.svg`
  position: relative;
  transform: rotate(0.25turn);
  width: 964px;
  height: 964px;
  border-radius: 964px;

  circle {
    fill: none;
    stroke-width: 22;
    stroke-linecap: round;
  }

  .progress {
    transition: stroke-dashoffset 0.35s;
    transform: scaleX(-1);
    transform-origin: center;
  }
`;

export const Timer4NowBlindWrapper = styled.div`
  position: relative;
  margin-top: 70px;
  width: 1020px;
  height: 191px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 35px;
  background: #002f68;
  align-items: center;
  justify-content: center;

  > .title {
    color: #fff;
    text-align: center;
    font-family: "Termina Test";
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .value {
    color: #fff;
    text-align: center;
    font-family: "Termina Test";
    font-size: 65px;
    font-style: normal;
    font-weight: 900;
    line-height: 64.51px; /* 99.247% */

    > span {
      color: #fff;
      font-family: "Termina Test";
      font-size: 47px;
      font-style: normal;
      font-weight: 900;
      line-height: 64.51px;
    }
  }
`;

export const Timer4NextBlindWrapper = styled.div`
  position: relative;
  margin-top: 10px;
  width: 1020px;
  height: 142px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 35px;
  background: #363636;
  align-items: center;
  justify-content: center;

  > .title {
    color: #b2c0d1;
    text-align: center;
    font-family: "Termina Test";
    font-size: 29.03px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > .value {
    color: #b2c0d1;
    text-align: center;
    font-family: "Termina Test";
    font-size: 45px;
    font-style: normal;
    font-weight: 900;
    line-height: 64.51px; /* 143.356% */

    > span {
      color: #b2c0d1;
      font-family: "Termina Test";
      font-size: 40px;
      font-style: normal;
      font-weight: 900;
      line-height: 64.51px;
    }
  }
`;

export const Timer4LeftWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 505px;
`;

export const Timer4LeftItemWrapper = styled.div<{ isRed: boolean }>`
  position: relative;
  width: 482px;
  padding-left: 30px;
  height: 160px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  justify-content: center;
  background: ${({ isRed }) =>
    isRed
      ? "linear-gradient(270deg, rgba(0, 20, 44, 0.80) 0.01%, rgba(255, 0, 0, 0.80) 99.99%)"
      : "linear-gradient(270deg, rgba(0, 20, 44, 0.2) 0%, rgba(211, 255, 91, 0.2) 100%)"};
  > .title {
    color: #fff;
    font-family: "Termina Test";
    font-size: 25px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > .value {
    color: #fff;
    font-family: "Termina Test";
    font-size: 45px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const Timer4RightWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  padding: 20px 10px;
  box-sizing: border-box;
  background: linear-gradient(
    90deg,
    rgba(0, 20, 44, 0.2) 0%,
    rgba(211, 255, 91, 0.2) 100%
  );
  width: 505px;
  height: 866px;
  align-items: flex-end;
  justify-content: space-between;

  > .prize-wrapper {
    margin-top: 10px;
    margin-right: 2px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
  }

  .title {
    font-size: 25px;
    font-weight: 700;
    line-height: 30px;
    text-align: right;
    color: white;
    margin-bottom: 20px;
  }
`;
export const Timer4Notice = styled.div`
  position: relative;
  color: #fff;
  font-size: 20px;
  font-weight: 500;
  width: 100%;
  height: 115px; /* 고정 높이 */
  padding: 10px;
  border-radius: 16px;
  box-sizing: border-box;
  line-height: 1.1; /* 줄 간격 설정 */
  text-overflow: ellipsis; /* 초과된 부분에 "..." 표시 */
  overflow-wrap: break-word;
  overflow: hidden; /* 내용이 넘치면 잘림 */
  display: -webkit-box; /* 웹킷 박스 모델로 설정 */
  -webkit-line-clamp: 4; /* 4줄로 제한 */
  -webkit-box-orient: vertical; /* 블록 방향 설정 */
  background: radial-gradient(
    69.9% 110.16% at 17.58% 4.3%,
    rgba(255, 0, 4, 0.4) 0%,
    rgba(255, 4, 8, 0.16) 78.06%
  );
`;

export const Timer4PrizeItemTop3 = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;

  > .rank {
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

const slideAnimation = keyframes`
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  15% {
    transform: translateY(0);
    opacity: 1;
  }
  85% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-30%);
    opacity: 0;
  }
`;

export const Timer4PrizeItem = styled.div<{ length: number }>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
  ${({ length }) =>
    length >= 11 &&
    css`
      animation: ${slideAnimation} 9s linear infinite;
    `}

  > .rank {
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;
